import app from 'flarum/common/app';
import emojis from 'simple-emoji-map';
import FuzzySet from 'fuzzyset';
const flatten = function (arr, depth) {
  if (depth === void 0) {
    depth = 1;
  }
  return arr.reduce((a, v) => a.concat(depth > 1 && Array.isArray(v) ? flatten(v, depth - 1) : v), []);
};
const shortnames = flatten(Object.values(emojis));
const entries = Object.entries(emojis);
const getEmoji = identifier => entries.find(_ref => {
  let [, value] = _ref;
  return value.includes(identifier);
});
const toUnicodeEmoji = codePoint => String.fromCodePoint(...codePoint.split('-').map(e => "0x".concat(e)));
const emojiCache = new Map();
const fuzzySet = new FuzzySet(shortnames);
const search = query => {
  const results = fuzzySet.get(query);
  if (!results) return null;
  const [score, item] = results[0];
  return {
    score,
    item
  };
};
export default function emoji(reactionOrIdentifier) {
  if (!reactionOrIdentifier) return {};
  let identifier = reactionOrIdentifier.identifier || reactionOrIdentifier;
  if (emojiCache.has(identifier)) return emojiCache.get(identifier);
  let score;
  if (!shortnames.includes(identifier)) {
    const match = search(identifier);
    identifier = match == null ? void 0 : match.item;
    score = match == null ? void 0 : match.score;
  }
  const emoji = getEmoji(identifier);
  const codePoint = emoji == null ? void 0 : emoji[0];
  const cdnUrl = app.forum.attribute('fofReactionsCdnUrl') || 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/[codepoint].png';
  const output = codePoint ? {
    identifier,
    score,
    uc: toUnicodeEmoji(codePoint),
    url: cdnUrl.replace('[codepoint]', codePoint.toLowerCase()),
    type: 'emoji'
  } : {};
  emojiCache.set(reactionOrIdentifier, output);
  return output || {};
}
flarum.reg.add('fof-reactions', 'common/util/emoji', emoji);